import styles from './Signature.module.scss';
import SignaturePad from 'react-signature-canvas';
import { Modal } from 'components/Modal/Modal';
import { useState } from 'react';

export const Signature = ({ sigUrl, setSigUrl }) => {
  const [openModal, setOpenModal] = useState(false);
  let sigRef = {};

  const clear = () => {
    sigRef.clear();
  };
  const trim = () => {
    setSigUrl(sigRef.getTrimmedCanvas().toDataURL('image/png'));
    setOpenModal(false);
  };
  return (
    <>
      <Modal open={openModal} handleClose={() => setOpenModal(false)}>
        <div className={styles.modal}>
          <div className={styles.sigPad}>
            <SignaturePad
              canvasProps={{ className: styles.canvas }}
              ref={(ref) => {
                sigRef = ref;
              }}
            />
          </div>
          <div className={styles.btns}>
            <button className='btn' onClick={() => clear()}>
              clear
            </button>
            <button className='btn' onClick={() => trim()}>
              save
            </button>
          </div>
        </div>
      </Modal>
      <div className={styles.container}>
        <div className={styles.innerContainer}>
          {sigUrl && (
            <button className={styles.deleteBtn} onClick={() => setSigUrl(null)}>
              <span>+</span>
            </button>
          )}
          {!sigUrl && (
            <button className={styles.addBtn} onClick={() => setOpenModal(true)}>
              +
            </button>
          )}
          {sigUrl && (
            <div className={styles.imgWrapper}>
              <img onClick={() => setOpenModal(true)} src={sigUrl}></img>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
